import { Model } from '@vuex-orm/core'

export default class Cpo extends Model {
    static get entity () {
        return 'cpo'
    }

    static fields () {
        return {
            id: this.uid(),
            title: this.string(''),
            dcs: this.string(''),
            directorate: this.string(''),
            isActive: this.boolean(true),
        }
    }
}
